import React from 'react';
import { Typography } from '@wbk/ui';
import { twMerge } from 'tailwind-merge';

const ScrollTitle = ({
  title,
  noColor,
  className,
}: {
  title: string;
  noColor?: boolean;
  className?: string;
}) => {
  const _title = title?.split('-')?.map((part, index, array) => {
    // Split the part into words and numbers
    const coloredText = part.split(/(\d+)/).map((segment, segIndex) => {
      // Check if segment is a number
      return /^\d+$/.test(segment) ? (
        <span key={segIndex} className='text-blue-500'>
          {segment}
        </span>
      ) : (
        segment
      );
    });

    return (
      <React.Fragment key={index}>
        {noColor ? part : coloredText}
        {index < array.length - 1 && <br />}
      </React.Fragment>
    );
  });

  return (
    <Typography
      as='h3'
      variant='body-XL'
      className={twMerge(
        'md:text-heading-XL font-semibold uppercase text-white md:leading-[48px]',
        className
      )}
    >
      {_title}
    </Typography>
  );
};

export default ScrollTitle;
